import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { useSnapshots } from '@/hooks/useAttendanceMetrics'
import { Loader2 } from 'lucide-react'

interface CompareSnapshotDropdownProps {
  currentSnapshotId: string
  selectedSnapshotId: string | null
  onSnapshotSelect: (snapshotId: string | null) => void
}

export function CompareSnapshotDropdown({
  currentSnapshotId,
  selectedSnapshotId,
  onSnapshotSelect,
}: CompareSnapshotDropdownProps) {
  const { data: snapshots, isLoading } = useSnapshots()

  // Filter out current snapshot
  const availableSnapshots = snapshots?.filter((s) => s.id !== currentSnapshotId) || []

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Loader2 className="h-4 w-4 animate-spin" />
        <span>Carregando relatórios...</span>
      </div>
    )
  }

  if (availableSnapshots.length === 0) {
    return (
      <div className="text-sm text-muted-foreground">
        Nenhum outro relatório disponível para comparação
      </div>
    )
  }

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
      <label className="text-sm font-medium whitespace-nowrap">Comparar com:</label>
      <Select
        value={selectedSnapshotId || 'none'}
        onValueChange={(value) => onSnapshotSelect(value === 'none' ? null : value)}
      >
        <SelectTrigger className="w-full sm:w-[280px]">
          <SelectValue placeholder="Selecione um relatório" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="none">Nenhum</SelectItem>
          {availableSnapshots.map((snapshot) => (
            <SelectItem key={snapshot.id} value={snapshot.id}>
              {snapshot.name || `Relatório ${new Date(snapshot.createdAt).toLocaleDateString('pt-BR')}`}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
